import {NavLink} from "react-router-dom";
import styled from "styled-components";
import Control from "./Control";

const Holder = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  padding: 1.5rem;
  color: ${(props) => props.isHome ? `var(--white)` : props.theme.colors.color1};

  nav {
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 1rem;

    a {
      margin: 0;
      text-align: left;
      font-weight: bold;
      line-height: 1;
      ${(props) => props?.theme?.fluidType(-1)};
      text-decoration: none;

      &.tool {
        margin-left: auto;
      }

      &.active {
        border-bottom: 2px solid;
      }
    }
  }
`;

const Logo = styled(NavLink)`
  height: 2rem;
  aspect-ratio: 1/1;
  &.active {
    border-bottom: none !important;
    svg {
      path,
      ellipse,
      circle,
      rect,
      polygon {
        fill: ${(props) => props.isHome ? `var(--white)` : props.theme.colors.color1} !important;
      }
    }
  }
`

const Header = ({isHome}) => {
  return (
    <Holder isHome={isHome}>
      <nav>
        <Logo to="/" isHome={isHome}>
          <Control />
        </Logo>
        <NavLink className="tool" to="/fvs-tool/">Tool</NavLink>
        <NavLink to="/gallery/">Gallery</NavLink>
      </nav>
    </Holder>
  );
};

export default Header;
